// PriceUtils.js - Utility functions for price calculations
// Formula: Final Price = (Gold Weight × Gold Price per Gram) + (Making Fee per Gram × Gold Weight)

/**
 * Calculate product price: (weight * pricePerGram) + (weight * makingFeePerGram)
 * @param {number|string} weight - Gold weight in grams
 * @param {number|string} pricePerGram - Gold price per gram
 * @param {number|string} makingFeePerGram - Global making fee per gram
 * @returns {object} - { goldValue, makingFee, totalPrice }
 */
export const calculateProductPrice = (weight, pricePerGram, makingFeePerGram) => {
  const w = Number(weight) || 0;
  const ppg = Number(pricePerGram) || 0;
  const mfpg = Number(makingFeePerGram) || 0;

  const goldValue = w * ppg;
  const makingFee = w * mfpg;
  const totalPrice = goldValue + makingFee;

  return {
    goldValue: parseFloat(goldValue.toFixed(2)),
    makingFee: parseFloat(makingFee.toFixed(2)),
    totalPrice: parseFloat(totalPrice.toFixed(2)),
  };
};
